export default "__VITE_ASSET__45d73806__"